import React from 'react'
import { PayHealthStipendFlowProvider } from './context/PayHealthStipendFlowProvider'
import { PayHealthStipendFlowMain } from './components/PayHealthStipendFlowMain'

export const PayHealthStipendFlow = () => (
  <PayHealthStipendFlowProvider>
    <PayHealthStipendFlowMain />
  </PayHealthStipendFlowProvider>
)
